import GcsOverview from '@/modules/integrations/types/gcs/GcsOverview'
import GcsSettings from '@/modules/integrations/types/gcs/GcsSettings'

export default Object.freeze({
  type: 'gcs',
  title: 'Integrations_Gcs',
  category: 'Integrations_Gcs_Category',
  description: 'Integrations_Gcs_Description',
  image: require('@/img/integrations/gcs.png'),
  requiresAdmin: false,
  components: {
    overview: GcsOverview,
    settings: GcsSettings
  },
  urls: {
    guide: 'https://docs.xtremepush.com/docs/third-party-integrations'
  }
})



// WEBPACK FOOTER //
// ./src/modules/integrations/types/gcs/index.js